<div class="row" [formGroup]="form">
  <div
    formArrayName="_data"
    class="col-12 mb-2"
    *ngFor="let field of dataFA.controls; let i = index"
  >
    <div class="form-row" [formGroupName]="i">
      <!-- Remove -->
      <div class="col-auto">
        <p class="small font-weight-bold mb-2" *ngIf="i === 0">
          &nbsp;
        </p>
        <button
          class="btn btn-outline-secondary btn-sm"
          (click)="onRemoveData(i)"
        >
          <i class="fe fe-trash fa-fw"></i>
        </button>
      </div>
      <!-- name -->
      <div class="col">
        <p class="small font-weight-bold mb-2" *ngIf="i === 0">
          {{ 'clients.client-add.form._data.name.label' | translate }}
        </p>
        <input
          type="text"
          class="form-control form-control-sm data-hj-whitelist"
          id="data_name_{{ i }}"
          name="data_name_{{ i }}"
          formControlName="name"
          placeholder="{{
            'clients.client-add.form._data.name.placeholder' | translate
          }}"
          [class.is-invalid]="
            sent &&
            form.get('_data.' + i + '.name').hasError('required')
          "
        />
      </div>
      <!-- value -->
      <div class="col">
        <p class="small font-weight-bold mb-2" *ngIf="i === 0">
          {{ 'clients.client-add.form._data.value.label' | translate }}
        </p>
        <input
          type="text"
          class="form-control form-control-sm data-hj-whitelist"
          id="data_value_{{ i }}"
          name="data_value_{{ i }}"
          formControlName="value"
          placeholder="{{
            'clients.client-add.form._data.value.placeholder'
              | translate
          }}"
        />
      </div>
    </div>
  </div>

  <div class="col-12">
    <button
      class="btn btn-outline-secondary btn-sm mt-3"
      type="button"
      (click)="onAddData()"
    >
      <i class="fe fe-plus"></i>
      {{ 'clients.client-add.form._data.add' | translate }}
    </button>
  </div>
</div>